<!-- dvquang2 15/10/2021 Tooltip click -->
<template>
  <div class="tooltip-container2">
    <div
      ref="conmstooltip2"
      class="con-ms-tooltip2"
      @mouseenter="toggleDefault($event)"
      @mouseleave="toggleDefault2($event)"
    >
      <slot></slot>
    </div>
    <DxTooltip
      class="ms-tooltips2"
      :visible="activeData"
      :close-on-outside-click="true"
      :target="popoverTarget"
      :position="position"
      v-if="showTooltips"
    >
      <slot name="text"></slot>
    </DxTooltip>
  </div>
</template>
<script>
import { DxTooltip } from "devextreme-vue/tooltip";

export default {
  name: "MsTooltip",
  components: {
    DxTooltip,
  },
  props: {
    showTooltips: {
      default: true,
      type: [Boolean],
    },
    color: {
      default: null,
      type: String,
    },
    position: {
      default: "top",
      type: String,
    },
    delay: {
      default: "0s",
      type: [Number, String],
    },
    active: {
      default: false,
      type: [Boolean],
    },
    direction: {
      type: String,
      default: "vertical",
    },
  },
  data: () => ({
    popoverTarget: null,
    activeData: false,
  }),
  mounted() {},
  methods: {
    toggleDefault(event) {
      this.popoverTarget = event.target;
      this.activeData = true;
      event.stopPropagation();
    },
    toggleDefault2(event) {
      this.popoverTarget = event.target;
      this.activeData = false;
      event.stopPropagation();
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/components/MsTooltip.scss";
</style>
